document.addEventListener('DOMContentLoaded', () => {
  const characterLength = 400;
  const readMoreTxt = '...Read more';
  const readLessTxt = 'Read less';

  document.addEventListener('click', (event) => {
    const tabLink = event.target.closest('.tab-link');

    if (tabLink) {
      const tabId = tabLink.getAttribute('data-tab');

      document.querySelectorAll('ul.tabs li').forEach((item) => item.classList.remove('active'));
      document.querySelectorAll('.tab-content').forEach((item) => item.classList.remove('active'));

      tabLink.classList.add('active');

      if (tabId) {
        const targetTab = document.getElementById(`tab-${tabId}`);
        if (targetTab) {
          targetTab.classList.add('active');
        }
      }

      return;
    }

    const readMore = event.target.closest('.read-more');
    if (readMore) {
      const container = readMore.parentElement;
      const hiddenContent = container?.querySelector('.SecSec');
      const readLess = container?.querySelector('.read-less');

      if (hiddenContent) hiddenContent.style.display = 'inline';
      readMore.style.display = 'none';
      if (readLess) readLess.style.display = 'inline';
      return;
    }

    const readLess = event.target.closest('.read-less');
    if (readLess) {
      const container = readLess.parentElement;
      const hiddenContent = container?.querySelector('.SecSec');
      const readMoreButton = container?.querySelector('.read-more');

      if (hiddenContent) hiddenContent.style.display = 'none';
      readLess.style.display = 'none';
      if (readMoreButton) readMoreButton.style.display = 'inline';
    }
  });

  if (window.location.hash) {
    const target = document.getElementById(window.location.hash.slice(1));
    if (target) {
      window.scrollTo({
        top: Math.max(target.getBoundingClientRect().top + window.scrollY - 150, 0),
        behavior: 'smooth',
      });
    }
  }

  document.querySelectorAll('.add-read-more').forEach((element) => {
    if (element.dataset.readMoreInitialized === 'true') {
      return;
    }

    const content = element.textContent?.trim() || '';
    if (content.length <= characterLength) {
      element.dataset.readMoreInitialized = 'true';
      return;
    }

    const firstPart = content.substring(0, characterLength);
    const secondPart = content.substring(characterLength);

    element.innerHTML = `${firstPart}<span class="SecSec" style="display:none;">${secondPart}</span><span class="read-more" style="color:blue; cursor:pointer;"> ${readMoreTxt}</span><span class="read-less" style="color:blue; cursor:pointer; display:none;"> ${readLessTxt}</span>`;
    element.dataset.readMoreInitialized = 'true';
  });
});
